import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function capitalize(str: string) {
    if (typeof str !== 'string' || str.length === 0) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatMoney(amount: number | string, currencySymbol = 'R$') {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (
        currencySymbol +
        ' ' +
        num.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    );
}

export function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function getFileTypeLabel(mimeType: string): string {
    const typeMap: { [key: string]: string } = {
        'application/pdf': 'PDF',
        'text/plain': 'Text',
        'text/csv': 'CSV',
        'application/vnd.ms-excel': 'Excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel',
    };
    return typeMap[mimeType] || 'Document';
}

/**
 * Corta o texto em até `maxLength` caracteres sem partir palavras, para meta descriptions. Quebras de linha e espaços
 * repetidos viram um espaço só. Quando corta, termina em "…" (contado no limite). Uma palavra maior que o limite
 * inteiro é cortada no meio, porque não há espaço onde parar.
 */
export function truncateAtWord(text: string | null | undefined, maxLength: number): string {
    if (maxLength < 1) {
        return '';
    }

    const normalized = (text ?? '').replace(/\s+/g, ' ').trim();

    if (normalized.length <= maxLength) {
        return normalized;
    }

    const room = normalized.slice(0, maxLength - 1);
    const lastSpace = room.lastIndexOf(' ');
    const cut = lastSpace > 0 ? room.slice(0, lastSpace) : room;

    return `${cut.replace(/[\s,.;:!?-]+$/, '')}…`;
}
